import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React__default, { useMemo } from 'react';
import { classNames } from '../../../helpers/classnames.js';

//todo переделать, после смены токенов придётся и тут менять
var sizeDictionary = {
    'standart': 44,
    'mini': 20
};
var strokeWidthDictionary = {
    'standart': 6,
    'mini': 3
};
// для совместимости number 
var getRadius = function (size) {
    var key = (size in sizeDictionary) ? size : 'standart';
    return (sizeDictionary[key] - strokeWidthDictionary[key]) / 2;
};
var CircleProgress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.size, size = _c === void 0 ? 'standart' : _c, _d = _a.cycled, cycled = _d === void 0 ? false : _d, className = _a.className, props = __rest(_a, ["value", "size", "cycled", "className"]);
    var radius = useMemo(function () { return getRadius(size); }, [size]);
    var CIRCUMFERENCE = useMemo(function () { return radius * 2 * Math.PI; }, [radius]);
    var strokeDasharray = "".concat(CIRCUMFERENCE, " ").concat(CIRCUMFERENCE);
    var limitedValue = useMemo(function () { return (value > 100 ? 100 : value); }, [value]);
    var completed = useMemo(function () { return limitedValue === 100; }, [limitedValue]);
    var strokeDashoffset = useMemo(function () { return CIRCUMFERENCE - (limitedValue / 100) * CIRCUMFERENCE; }, [CIRCUMFERENCE, limitedValue]);
    return (React__default.createElement("div", __assign({ "data-testid": "CircleProgress" }, props, { className: classNames('dsb_progress__circular-wrapper', className) }),
        React__default.createElement("svg", { className: classNames('dsb_progress', (size === 'mini' ? 'dsb_progress__circular_mini' : 'dsb_progress__circular_standart')) },
            React__default.createElement("circle", { className: "dsb_progress-circle__track" }),
            React__default.createElement("circle", { className: classNames('dsb_progress-circle__indication', cycled && 'dsb_progress-circle__cycled', completed && 'dsb_progress-circle__indication_completed'), style: { strokeDashoffset: strokeDashoffset, strokeDasharray: strokeDasharray } }))));
};

export { CircleProgress };
